"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import { siteSettingsKeys } from "../../shared/keys";
import type { SiteSettings } from "../../shared/types";

const DEFAULT_IMAGE_RATIO = 0.75;

export function useSiteSettings() {
  const locale = useLocale();

  const { data, isLoading } = useQuery<SiteSettings>({
    queryKey: siteSettingsKeys.settings(),
    queryFn: () => fetcher<SiteSettings>(`/${locale}/api/settings`),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    imageRatio: data?.imageRatio ?? DEFAULT_IMAGE_RATIO,
    isLoading,
  };
}
